export default __webpack_public_path__ + "static/photo-16-79670dc8536410f6622fb9efe5edcf4b.jpg";